<template>
  <label class="bk-checkbox-toggle">
    <input v-model="value" type="checkbox" class="peer" :disabled />
    <div class="bk-checkbox-toggle-toggle" />
    <div class="bk-checkbox-toggle-label">
      <div>{{ label }}</div>
      <div v-if="description">
        {{ description }}
      </div>
    </div>
  </label>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  description: { type: String, required: false },
  disabled: { type: Boolean, required: false }
});
const value = defineModel({ type: Boolean });
</script>
